import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Lender.Save.IRequest;
type Response = Api.Core.Lender.Save.IResponse;
type Headers = Api.Core.Lender.Save.IHeaders;
const url = '/api/Sales/Lender';
export default async function LenderSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
